import React, { } from "react";
import HelpWindow from "./HelpWindow";
import { Typography } from "@mui/material";

export const Help_selectClient = () => {
    return (
        <HelpWindow title="Select Client" >
            <Typography variant="body1" gutterBottom>
                Click on the client that you want to work with.  Once you have a client selected, you will be able to access its accounts/rules and scenarios.

                <b>Personal</b> clients those related to this subscriber.<br />
                <b>Shared</b> clients ones that another MyOwnFP subscriber has shared with you.  Currently if you access this it will be readonly.<br />
                <b>Public</b> clients are those that MyOwnFP or another subscriber has made public.  This is meant for educational purposes on seeing what features are available.  ** Currently no user (other than myownfp) can make it's personal clients public. <br />
                <br />
                <b>+</b> Creates a new client.<br />
                <b>Edit</b> allows you to edit the client basic data.<br />
                <b>Copy</b> allows you to copy the client to a new client.<br />
                <li><b>Restricted</b> You can copy these without having a subscription (if you have a subscription it will not count to your subscription total), though you cannot modify the client or add accounts/rules (though you can add/change the data in any year for those accounts).  You can change a few items in the scenario tab or sweeps.</li>
                <li><b>Scenarios</b> This will copy the client and all their scenarios.</li>
            </Typography>
        </HelpWindow>
    )
}

export const Help_selectScenario = () => {
    return (
        <HelpWindow title="Select Scenarios" >
            <Typography variant="body1" gutterBottom>
                <b>Scenarios</b> all the scenarios are related to the current client.<br />
                <b>Sweeps</b> all the sweeps related to the current client.<br />
                <br />
                <b>View</b> Takes you to the grid of all the accounts.<br />
                <b>Compare</b> Once you select 2 scenarios to compare you will be able to select which accounts you wish to compare.<br />
                <b>Copy</b>
                <li>Allows you to copy the scenario to another scenario to make changes to make it a different scenario.</li>
                <li>Allows you to copy all the detail (accounts/rules) of the scenario to the base client.</li>


            </Typography>
        </HelpWindow>
    )
}